import { useEffect } from "react";
import "@/App.css";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import { initLenis } from "./lib/smooth";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { ServicesIntro } from "./components/ServicesIntro";
import { ServiceBlock } from "./components/ServiceBlock";
import { Process } from "./components/Process";
import { Clients } from "./components/Clients";
import { About } from "./components/About";
import { Instagram } from "./components/Instagram";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsApp";
import { SERVICES } from "./data/content";

function App() {
  useEffect(() => {
    const destroy = initLenis();
    return () => { destroy(); };
  }, []);

  return (
    <div className="grain bg-[#FAF8F5] text-[#1A1816]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ServicesIntro />
        <About />
        <Instagram />
        {SERVICES.map((s, i) => (
          <div key={s.id} className={i % 2 ? "bg-[#F3EFEA]" : ""}>
            <ServiceBlock s={s} flip={i % 2 === 1} />
          </div>
        ))}
        <Clients />
        <Process />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster position="bottom-center" toastOptions={{ style: { fontFamily: "IBM Plex Sans, sans-serif", fontSize: 16 } }} />
    </div>
  );
}

export default App;
